import { Inject } from '@odinjs/odin';
import { RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import Controller, { OnCancel, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { ContextType, SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { FragmentNames, PseudonymSuggestionTypeConsultationAliases } from '../../../codegen';
import PseudonymAppointmentsBaseController from '../pseudonym-appointments-base-controller';
import { TeleconsultationType } from '../pseudonym-types';

@Controller({ component: PseudonymSuggestionTypeConsultationAliases.LAYOUT_SUGGESTION_TYPE_CONSULTATION, fragment: FragmentNames.PSEUDONYM_SUGGESTION_TYPE_CONSULTATION })
export default class PseudonymSuggestionTypeConsultationController extends PseudonymAppointmentsBaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @OnMount({ target: PseudonymSuggestionTypeConsultationAliases.RADIO_GROUP_SUGGESTION_TYPE_CONSULTATION })
  handleOnMountRadioGroupSuggestionTypeConsultation(evt: MountEvent): void {
    const radioGroup = evt.target as RadioGroupAPI;
    const indentifyTypes = [
      { key: TeleconsultationType.TELECONSULTATION, label: MessageService.translate('patient.teleconsultation'), value: TeleconsultationType.TELECONSULTATION },
      { key: TeleconsultationType.IN_PERSON, label: MessageService.translate('text.in-person'), value: TeleconsultationType.IN_PERSON }
    ] as Array<SelectableItem>;
    radioGroup.setData(indentifyTypes);
  }

  @OnSubmit({ target: PseudonymSuggestionTypeConsultationAliases.FORM_SUGGESTION_TYPE_CONSULTATION })
  handleOnSubmitFormSuggestionTypeConsultation(evt: SubmitEvent): void {
    this.submittableFragmentContext.submit(new SubmitEvent({ record: evt.record }));
  }

  @OnCancel({ target: PseudonymSuggestionTypeConsultationAliases.FORM_SUGGESTION_TYPE_CONSULTATION })
  handleOnCancelFormSuggsetionTypeConsultation(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

}
